module.exports = __webpack_public_path__ + "static/media/choose-plan-single-company-rsm.e6af69eb.svg";